var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 236.9a8.8 8.8 0 01-5.5-1.9 8.9 8.9 0 01-1.6-12.6l55.7-71.5-55.8-73.4a9 9 0 0114.4-10.9l64.2 84.4-64.3 82.4a8.9 8.9 0 01-7.1 3.5z"
  })));
}
export default SvgIconChevronRight;